module.exports = __webpack_public_path__ + "img/electric_reserved.c34a3ee6.svg";